export const replaceText = (text, model) => {
    let about = text;
    if (about) {
        for (var propertyName in model) {
            var pattern = `\\*\\|${propertyName}\\|\\*`;
            var regex = new RegExp(pattern, "g");
            about = about.replace(regex, model[propertyName] || '');
        }
    }
    return about;
}